import { useDispatch, useSelector } from "react-redux";

import { DepotIcon } from "./Icons";
import { View } from "./View";
import { getBbox } from "../utils/map";
import { lookupTableSelector } from "../reducers/depot/selectors";
import { makeStyles } from "@mui/styles";
import { setFitBounds } from "../reducers/map/thunkActions";

const useStyles = makeStyles({
  container: {
    cursor: "pointer",
    width: "26px",
    height: "26px",
    borderRadius: "2px",
    position: "absolute",
    backgroundColor: "white",
    inset: "auto 10px 70px auto",
    boxShadow: "rgb(0 0 0 / 30%) 0px 1px 4px",
    opacity: "0.95",
    zIndex: "10",
  },
  icon: {
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
});

export const HomeDepotController = () => {
  const lookupTable = useSelector(lookupTableSelector);
  const dispatch = useDispatch();
  const styles = useStyles();

  const onClick = () => {
    if (!lookupTable?.OUTER) return;

    dispatch(
      setFitBounds({
        bbox: getBbox({
          postcodes: Object.keys(lookupTable.OUTER),
          lookupTable: lookupTable.OUTER,
        }),
      })
    );
  };

  return (
    <View className={styles.container} onClick={onClick}>
      <DepotIcon className={styles.icon} />
    </View>
  );
};
